const financeManagementRouteFormatter = (url) => `finances/bcc/${url}`;

export const getFinanceManagementTableRoute = () =>
  financeManagementRouteFormatter('invoiceTable');
